import React, { useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { RadioButton } from 'primereact/radiobutton';
import { PasswordResetType } from '../../../../../../api/types/auth/reset-password-type';

interface WarningDialogProps {
  visible: boolean;
  onConfirm: (resetType: PasswordResetType) => void;
  onCancel: () => void;
}

export const WarningDialog: React.FC<WarningDialogProps> = ({
  visible,
  onConfirm,
  onCancel,
}) => {
  const [selectedResetType, setSelectedResetType] = useState<PasswordResetType>(
    PasswordResetType.PhoneNumber,
  );

  const handleConfirm = () => {
    onConfirm(selectedResetType);
  };

  const handleCancel = () => {
    setSelectedResetType(PasswordResetType.PhoneNumber);
    onCancel();
  };

  const footer = (
    <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
      <Button
        label="כן, שנה סיסמא"
        icon="pi pi-check"
        onClick={handleConfirm}
        severity="warning"
        style={{
          padding: '8px 16px',
          borderRadius: '6px',
        }}
      />
    </div>
  );

  return (
    <Dialog
      header="שינוי סיסמא"
      visible={visible}
      onHide={handleCancel}
      style={{ width: '450px' }}
      footer={footer}
      modal
      draggable={false}
      resizable={false}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '16px',
          padding: '16px',
        }}
      >
        <i
          className="pi pi-exclamation-triangle"
          style={{ fontSize: '2.5rem', color: '#f59e0b' }}
        />
        <div>
          <p
            style={{
              margin: '0',
              fontSize: '1.1rem',
              color: '#212529',
              fontWeight: '500',
            }}
          >
            האם תרצה לשנות את הסיסמא?
          </p>
          <p
            style={{
              margin: '8px 0 0 0',
              fontSize: '0.9rem',
              color: '#6c757d',
            }}
          >
            בחר כיצד לקבל את קוד האימות
          </p>
        </div>
      </div>

      <div
        style={{
          padding: '16px',
          display: 'flex',
          flexDirection: 'column',
          gap: '12px',
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            padding: '12px',
            backgroundColor:
              selectedResetType === PasswordResetType.PhoneNumber
                ? '#e3f2fd'
                : '#f8f9fa',
            borderRadius: '8px',
            border:
              selectedResetType === PasswordResetType.PhoneNumber
                ? '1px solid #90caf9'
                : '1px solid #dee2e6',
            cursor: 'pointer',
          }}
          onClick={() => setSelectedResetType(PasswordResetType.PhoneNumber)}
        >
          <RadioButton
            inputId="phoneNumber"
            name="resetType"
            value={PasswordResetType.PhoneNumber}
            onChange={(e) => setSelectedResetType(e.value)}
            checked={selectedResetType === PasswordResetType.PhoneNumber}
          />
          <label
            htmlFor="phoneNumber"
            style={{
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
            }}
          >
            <i className="pi pi-mobile" style={{ color: '#1976d2' }} />
            <span>שליחת קוד לטלפון הנייד</span>
          </label>
        </div>

        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            padding: '12px',
            backgroundColor:
              selectedResetType === PasswordResetType.Mail
                ? '#e3f2fd'
                : '#f8f9fa',
            borderRadius: '8px',
            border:
              selectedResetType === PasswordResetType.Mail
                ? '1px solid #90caf9'
                : '1px solid #dee2e6',
            cursor: 'pointer',
          }}
          onClick={() => setSelectedResetType(PasswordResetType.Mail)}
        >
          <RadioButton
            inputId="mail"
            name="resetType"
            value={PasswordResetType.Mail}
            onChange={(e) => setSelectedResetType(e.value)}
            checked={selectedResetType === PasswordResetType.Mail}
          />
          <label
            htmlFor="mail"
            style={{
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
            }}
          >
            <i className="pi pi-envelope" style={{ color: '#1976d2' }} />
            <span>שליחת קוד לכתובת האימייל</span>
          </label>
        </div>
      </div>
    </Dialog>
  );
};
